import React from "react";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../../layout/inputWrapper";
import { useTranslation } from "react-i18next";

const SubStep3 = ({ formData, handleSubTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...formData?.professionalInformation,
      consultantCategory: formData?.professionalInformation?.consultantCategory,
    },
  };
  const { handleSubmit, control } = useForm({ defaultValues });
  const onSubmit = (data) => {
    data = {
      ...data,
      professionalInformation: {
        ...data.professionalInformation
      },
    };
    handleSubTabChange(2, data);
  };
  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Professional (LTP) Information")}</h2>
          </div>
          <Container className="formInputContainer common-app-form px-4" fluid>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Consultant Category"
                  control={control}
                  disabled={Boolean(formData?.professionalInformation?.consultantCategory) || isEmployee}
                  placeholder="Enter Consultant Category"
                  name="professionalInformation.consultantCategory"
                  type="textInput"
                  defaultValue={formData?.professionalInformation?.consultantCategory}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={30}
                  className={Boolean(formData?.professionalInformation?.consultantCategory) ? "input-disabled" : ""}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Name"
                  control={control}
                  disabled
                  placeholder="Enter Name"
                  name="professionalInformation.name"
                  validation={{
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  isRequired={true}
                  type="textInput"
                  mandatory
                  maxLength={30}
                  
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Validity"
                  control={control}
                  placeholder="Validity"
                  name="professionalInformation.validupto"
                  type="textInput"
                  disabled={isEmployee}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Mobile No."
                  control={control}
                  placeholder="Enter Mobile No."
                  disabled
                  name="professionalInformation.mobileNumber"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Certificate No. (For Minimum Qualification)"
                  control={control}
                  name="professionalInformation.registrationArchitectNumber"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  height="30px"
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="License No."
                  control={control}
                  name="professionalInformation.registrationNumber"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="E-mail Id"
                  control={control}
                  disabled
                  placeholder="Enter E-mail Id"
                  defaultValue={formData?.professionalInformation?.emailId}
                  name="professionalInformation.emailId"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            {!isEmployee && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(1)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep3;
